import { Schema, arrayOf, unionOf } from 'normalizr'
import humps from 'humps'

export const areaActivitySchema = new Schema('areaActivities')
export const areaHistorySchema = new Schema('areaHistories')
export const areaSchema = new Schema('areas')
export const areaTypeSchema = new Schema('areaTypes')
export const commentSchema = new Schema('comments')
export const contractSchema = new Schema('contracts')
export const deviceSchema = new Schema('device')
export const locationSchema = new Schema('locations')
export const inspectorSchema = new Schema('inspectors')
export const inspectionSchema = new Schema('inspections')
export const issueSchema = new Schema('issues')
export const issueDescriptionSchema = new Schema('issueDescriptions')
export const issueHistorySchema = new Schema('issueHistories')
export const messageSchema = new Schema('messages')
export const msdsSheetSchema = new Schema('msdsSheets')
export const pinHistorySchema = new Schema('pinHistories')
export const pinSchema = new Schema('pins')
export const serviceSchema = new Schema('services')
export const serviceSummarySchema = new Schema('serviceSummaries')
export const workAreaSummarySchema = new Schema('workAreaSummaries')
export const subLocationSchema = new Schema('subLocations')
export const technicianServiceSummarySchema = new Schema('technicianServiceSummaries')
export const servicingSchema = new Schema('servicings')
export const servicingVersionsSchema = new Schema('servicingVersions')
export const servicingLabelSchema = new Schema('servicingLabels')
export const technicianWorkSummarySchema = new Schema('technicianWorkSummaries')
export const technicianServicingVersionsSchema = new Schema('technicianServicingVersions')
export const userSchema = new Schema('users')
export const workOrderSchema = new Schema('workOrders')
export const qaServicingSchema = new Schema('qaServicings')
export const qaTaskSchema = new Schema('qaTasks')
export const qaWorkOrderSchema = new Schema('qaWorkOrders')
export const reportSchema = new Schema('reports')
export const workSummarySchema = new Schema('workSummaries')
export const workTrackerSchema = new Schema('workTrackers')

const activity = {
  comments: commentSchema,
  areaHistories: areaHistorySchema
}

const summary = {
  workOrders: workOrderSchema,
  qaWorkOrders: qaWorkOrderSchema
}

locationSchema.define({
  areas: arrayOf(areaSchema),
  accountManagers: arrayOf(userSchema)
})

issueHistorySchema.define({
  issue: issueSchema,
  updatedBy: userSchema,
  issueDescription: issueDescriptionSchema
})

issueSchema.define({
  area: areaSchema,
  location: locationSchema,
  issueDescription: issueDescriptionSchema,
  submittedBy: userSchema,
  resolvedBy: userSchema,
  services: arrayOf(serviceSchema),
  latestHistory: issueHistorySchema
})

workOrderSchema.define({
  location: locationSchema,
  technicians: arrayOf(userSchema),
  servicings: arrayOf(servicingSchema)
})

servicingSchema.define({
  services: arrayOf(serviceSchema),
  workOrder: workOrderSchema,
  completedBy: userSchema,
  createdBy: userSchema,
  deletedBy: userSchema,
  assignee: userSchema,
  area: areaSchema,
  location: locationSchema
})

messageSchema.define({
  user: userSchema,
  workOrder: workOrderSchema,
  dismissedBy: userSchema
})

areaSchema.define({
  areaType: areaTypeSchema,
  pinnedComment: commentSchema,
  pins: arrayOf(pinSchema),
  latestHistory: areaHistorySchema
})

pinSchema.define({
  area: areaSchema,
  histories: arrayOf(pinHistorySchema),
  latestHistory: pinHistorySchema
})

pinHistorySchema.define({
  user: userSchema
})

areaHistorySchema.define({
  technician: userSchema
})

areaActivitySchema.define({
  activity: unionOf(
    activity,
    {
      schemaAttribute (association) {
        var type = humps.camelize(association.type)

        if (type === 'comment') {
          return 'comments'
        } else {
          return 'areaHistories'
        }
      }
    }
  )
})

commentSchema.define({
  user: userSchema
})

servicingLabelSchema.define({
  location: locationSchema
})

qaServicingSchema.define({
  area: areaSchema,
  qaWorkOrder: qaWorkOrderSchema,
  qaTasks: arrayOf(qaTaskSchema)
})

qaTaskSchema.define({
  qaServicing: qaServicingSchema
})

qaWorkOrderSchema.define({
  location: locationSchema,
  qaServicings: arrayOf(qaServicingSchema)
})

workSummarySchema.define({
  location: locationSchema,
  summary: unionOf(
    summary,
    {
      schemaAttribute (association) {
        var type = humps.camelize(association.type)

        if (type === 'workOrder') {
          return 'workOrders'
        } else {
          return 'qaWorkOrders'
        }
      }
    }
  )
})

technicianWorkSummarySchema.define({
  location: locationSchema
})



// WEBPACK FOOTER //
// ./src/schemas/index.js